import React, { useState } from "react";
import PropTypes from "prop-types";
import IconButton from "@material-ui/core/IconButton";
import CaseMediaTips from ".";
import lightBulb from "../../assets/icons/light_bulb.svg";

const CaseMediaTipsButton = ({ page, className }) => {
  const [showTips, setShowTips] = useState(false);

  const handleShowTips = () => setShowTips(true);
  const handleCloseTips = () => setShowTips(false);

  return (
    <>
      <IconButton onClick={handleShowTips} className={className}>
        <img src={lightBulb} alt="" />
      </IconButton>
      <CaseMediaTips onClose={handleCloseTips} open={showTips} page={page} />
    </>
  );
};

CaseMediaTipsButton.propTypes = {
  page: PropTypes.string.isRequired,
  className: PropTypes.string
};

CaseMediaTipsButton.defaultProps = {
  className: null
};

export default CaseMediaTipsButton;
